// GENERAL ICONS
export const userAvatar = new URL('@/assets/img/user_generic_avatar.png', import.meta.url).href;
export const cookiesImage = new URL('@/assets/img/cookies.png', import.meta.url).href;

// HOMEPAGE BUTTONS ICONS
// export const howItWorks = new URL('@/assets/img/icon_service_homepage.png', import.meta.url).href;
// export const aboutApp = new URL('@/assets/img/icon_app_homepage.png', import.meta.url).href;
export const howItWorks = new URL('@/assets/img/homepage_how_it_works.png', import.meta.url).href;
export const aboutApp = new URL('@/assets/img/homepage_about_app.png', import.meta.url).href;

// APPS AND SOCIAL ICONS
export const apple = new URL('@/assets/img/download_ios.png', import.meta.url).href;
export const googlePlay = new URL('@/assets/img/download_android.png', import.meta.url).href;
//// Rating icons
export const halfStar = new URL('@/assets/img/half_star.png', import.meta.url).href;
export const fullStar = new URL('@/assets/img/full_star.png', import.meta.url).href;

// CITY LOGOS
export const barcelonaLogo = new URL('@/assets/img/cityLogos/barcelona.png', import.meta.url).href;
export const valenciaLogo = new URL('@/assets/img/cityLogos/valencia.png', import.meta.url).href;
export const sevillaLogo = new URL('@/assets/img/cityLogos/sevilla.png', import.meta.url).href;
export const malagaLogo = new URL('@/assets/img/cityLogos/malaga.png', import.meta.url).href;
export const zaragozaLogo = new URL('@/assets/img/cityLogos/zaragoza.png', import.meta.url).href;
export const parisLogo = new URL('@/assets/img/cityLogos/paris.png', import.meta.url).href;
export const bordeauxLogo = new URL('@/assets/img/cityLogos/bordeaux.png', import.meta.url).href;
export const toulouseLogo = new URL('@/assets/img/cityLogos/toulouse.png', import.meta.url).href;
export const niceLogo = new URL('@/assets/img/cityLogos/nice.png', import.meta.url).href;

// HOW IT WORKS IMAGES
export const howItWorksHeader = new URL('@/assets/img/servicephoto.png', import.meta.url).href;
export const scooterMarkerIcon = new URL('@/assets/img/scooter-icon.png', import.meta.url).href;
export const team = new URL('@/assets/img/team-photo.jpg', import.meta.url).href;
export const ambLogo = new URL('@/assets/img/amb_logo.png', import.meta.url).href;
export const highway = new URL('@/assets/img/highway.png', import.meta.url).href;
export const station = new URL('@/assets/img/station_icon_servicepage.png', import.meta.url).href;
export const nokeys = new URL('@/assets/img/nokeysicon_servicepage.png', import.meta.url).href;
export const natureIcon = new URL('@/assets/img/natureicon_servicepage.png', import.meta.url).href;
export const scooter = new URL('@/assets/img/e-scooter.png', import.meta.url).href;
export const insurance = new URL('@/assets/img/insuranceicon_servicepage.png', import.meta.url)
  .href;
export const helmets = new URL('@/assets/img/helmetsicon_servicepage.png', import.meta.url).href;
export const power = new URL('@/assets/img/batteryicon_servicepage.png', import.meta.url).href;
export const openIcon = new URL('@/assets/img/open247icon_servicepage.png', import.meta.url).href;
export const openIconDaily = new URL('@/assets/img/icons_daily.png', import.meta.url).href;
export const priceStandard = new URL('@/assets/img/price_standard.jpg', import.meta.url).href;
export const carteJeune = new URL('@/assets/img/carte-jeune.jpg', import.meta.url).href;
export const scooterIcon = new URL('@/assets/img/scooter.png', import.meta.url).href;
export const movesLogo = new URL('@/assets/img/moves-logo.jpg', import.meta.url).href;

export const carteJeuneBanner = {
  es: new URL('@/assets/img/banner-es.svg', import.meta.url).href,
  en: new URL('@/assets/img/banner-en.svg', import.meta.url).href,
  fr: new URL('@/assets/img/banner-fr.svg', import.meta.url).href,
  ca: new URL('@/assets/img/banner-cat.svg', import.meta.url).href,
};

// ABOUT APP IMAGES
export const aboutAppHeader = new URL('@/assets/img/about-app.jpg', import.meta.url).href;
export const bookingScreen = {
  es: new URL('@/assets/img/appMockups/app_presentation1_es.png', import.meta.url).href,
  en: new URL('@/assets/img/appMockups/app_presentation1_en.png', import.meta.url).href,
  fr: new URL('@/assets/img/appMockups/app_presentation1_fr.png', import.meta.url).href,
  ca: new URL('@/assets/img/appMockups/app_presentation1_ca.png', import.meta.url).href,
};

export const rideScreen = {
  es: new URL('@/assets/img/appMockups/app_presentation2_es.png', import.meta.url).href,
  en: new URL('@/assets/img/appMockups/app_presentation2_en.png', import.meta.url).href,
  fr: new URL('@/assets/img/appMockups/app_presentation2_fr.png', import.meta.url).href,
  ca: new URL('@/assets/img/appMockups/app_presentation2_ca.png', import.meta.url).href,
};

export const endRideScreen = {
  es: new URL('@/assets/img/appMockups/app_presentation3_es.png', import.meta.url).href,
  en: new URL('@/assets/img/appMockups/app_presentation3_en.png', import.meta.url).href,
  fr: new URL('@/assets/img/appMockups/app_presentation3_fr.png', import.meta.url).href,
  ca: new URL('@/assets/img/appMockups/app_presentation3_ca.png', import.meta.url).href,
};

export const confirmationModalScreen = {
  es: new URL('@/assets/img/appMockups/app_presentation4_es.png', import.meta.url).href,
  en: new URL('@/assets/img/appMockups/app_presentation4_en.png', import.meta.url).href,
  fr: new URL('@/assets/img/appMockups/app_presentation4_fr.png', import.meta.url).href,
  ca: new URL('@/assets/img/appMockups/app_presentation4_ca.png', import.meta.url).href,
};

// DRIVING LESSONS IMAGES
export const drivingLessonsHeader = new URL('@/assets/img/driving_lessons_bg.png', import.meta.url)
  .href;
export const drivingLessonsHeaderDesktop = new URL(
  '@/assets/img/driving_lessons_bg_desktop.png',
  import.meta.url,
).href;
export const drivingLessons1 = new URL('@/assets/img/driving_1.png', import.meta.url).href;
export const drivingLessons2 = new URL('@/assets/img/driving_2.png', import.meta.url).href;
export const drivingLessons3 = new URL('@/assets/img/driving_3.png', import.meta.url).href;
export const greenHeart = new URL('@/assets/img/green_heart.png', import.meta.url).href;
export const checkList = new URL('@/assets/img/check_list.png', import.meta.url).href;
export const cone = new URL('@/assets/img/cone.png', import.meta.url).href;
export const quotes = new URL('@/assets/img/quotes.png', import.meta.url).href;
export const cheersIcon = new URL('@/assets/img/cheersicon_apppage.png', import.meta.url).href;

export const scooterRepairing = new URL('@/assets/img/scooter-repairing.png', import.meta.url).href;

// FAQ IMAGES
export const faqHeader = new URL('@/assets/img/faq-photo.jpg', import.meta.url).href;
